import React from 'react'
import { Show, TextField } from '@refinedev/antd'
import { useShow } from '@refinedev/core'
import { Typography, Tag } from 'antd'
import type { Tables } from '@muaa/shared'

type Campaign = Tables<'campaigns'>

const { Title } = Typography

export function CampaignShow() {
  const { query } = useShow<Campaign>()
  const { data, isLoading } = query
  const record = data?.data

  const formatMoney = (value: number | undefined) =>
    value != null
      ? `$${Number(value).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      : '—'

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>Title</Title>
      <TextField value={record?.title} />

      <Title level={5}>Raised</Title>
      <TextField value={formatMoney(record?.raised)} />

      <Title level={5}>Goal</Title>
      <TextField value={formatMoney(record?.goal)} />

      <Title level={5}>Donors</Title>
      <TextField value={record?.donors != null ? String(record.donors) : '—'} />

      <Title level={5}>Days Remaining</Title>
      <TextField value={record?.days_remaining != null ? String(record.days_remaining) : '—'} />

      <Title level={5}>Active</Title>
      {record != null ? (
        <Tag color={record.is_active ? 'green' : 'default'}>
          {record.is_active ? 'Active' : 'Inactive'}
        </Tag>
      ) : (
        <TextField value="—" />
      )}
    </Show>
  )
}
